import React, { useState } from 'react';
import {
  FaYoutube, FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP,
  FaQuora, FaRedditAlien, FaTwitter, FaCopy
} from 'react-icons/fa';
import { SiTiktok, SiThreads } from 'react-icons/si';

export default function SocialMediaShare({ postId }) {
  const [copied, setCopied] = useState(false);
  const postUrl = `https://million2trillion.com/blog/${postId}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(postUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  const socialLinks = [
    {
      name: 'YouTube',
      icon: <FaYoutube />,
      url: `https://youtube.com/@million2trillionofficial?si=fiCg78phVOU9A2yA`
    },
    {
      name: 'LinkedIn',
      icon: <FaLinkedinIn />,
      url: `https://www.linkedin.com/company/million2trillionofficial/`
    },
    {
      name: 'Facebook',
      icon: <FaFacebookF />,
      url: `https://www.facebook.com/profile.php?id=61576664019656`
    },
    {
      name: 'Instagram',
      icon: <FaInstagram />,
      url: `https://www.instagram.com/million2trillionofficial`
    },
    {
      name: 'X (Twitter)',
      icon: <FaTwitter />,
      url: `https://x.com/M2Tofficial?s=09`
    },
    {
      name: 'Threads',
      icon: <SiThreads />,
      url: `https://www.threads.net/@million2trillionofficial`
    },
    {
      name: 'Pinterest',
      icon: <FaPinterestP />,
      url: `https://www.pinterest.com/M2Tofficial`
    },
    {
      name: 'Quora',
      icon: <FaQuora />,
      url: `https://www.quora.com/profile/Million2Trillion`
    },
    {
      name: 'Reddit',
      icon: <FaRedditAlien />,
      url: `https://www.reddit.com/user/M2Tofficial`
    },
    {
      name: 'TikTok',
      icon: <SiTiktok />,
      url: `https://www.tiktok.com/@m2t_official_`
    }
  ];

  return (
    <div className="mt-4 border-t border-gray-800 pt-4 text-sm">
      <div className="mb-2 text-gray-300 font-semibold">Post URL</div>

      <div className="flex items-center gap-3 bg-gray-800 px-3 py-2 rounded-md">
        <span className="truncate">{postUrl}</span>
        <button onClick={handleCopy} title="Copy URL">
          <FaCopy className="text-xl hover:text-yellow-400" />
        </button>
        {copied && <span className="text-green-400 text-xs ml-2">Copied!</span>}
      </div>

      <div className="grid grid-cols-5 gap-4 mt-4 text-white text-xl">
        {socialLinks.map((s, idx) => (
          <a key={idx} href={s.url} target="_blank" rel="noopener noreferrer" title={s.name}>
            <div className="hover:text-yellow-400">{s.icon}</div>
          </a>
        ))}
      </div>
    </div>
  );
}
